import { EchartDataType, GroupRowType } from "helpers/models";
import fathomArray from "report/common/sort-lable-fathom";
import sortLayerBottom from "./sort-layer-bottom";

export default (
  groupEchart: EchartDataType,
  layerRuleOrder: { [key: string]: string[] }
) => {
  Object.values(groupEchart).forEach((group) => {
    for (const layerId in group) {
      const layer = group[layerId];
      const reversedLayerRule = [...layerRuleOrder[layerId]].reverse();
      const otherArray = sortLayerBottom(reversedLayerRule);
      const orderArray = layerId.includes("Fathom") ? fathomArray : otherArray;

      if (orderArray) {
        layer.sort((a: GroupRowType, b: GroupRowType) => {
          return orderArray.indexOf(a.label) - orderArray.indexOf(b.label);
        });
      }
    }
  });
};
